(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ventazano-capa-revista"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-vz-capa]').forEach((capa) => {
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    let pedido = 0;
    const aplicar = (x, y) => {
      cancelAnimationFrame(pedido);
      pedido = requestAnimationFrame(() => {
        capa.style.setProperty('--mx', x.toFixed(3));
        capa.style.setProperty('--my', y.toFixed(3));
        capa.style.setProperty('--luz-x', `${38 + x * 14}%`);
        capa.style.setProperty('--luz-y', `${34 + y * 10}%`);
      });
    };

    // Com rato: as camadas separam-se na direção do cursor, cada uma à sua
    // profundidade. -1..1 a partir do centro da capa.
    if (matchMedia('(hover: hover) and (pointer: fine)').matches) {
      capa.addEventListener('pointermove', (e) => {
        const r = capa.getBoundingClientRect();
        aplicar(((e.clientX - r.left) / r.width) * 2 - 1, ((e.clientY - r.top) / r.height) * 2 - 1);
      });
      capa.addEventListener('pointerleave', () => aplicar(0, 0));
      return;
    }

    // Sem rato: o scroll faz o mesmo papel. O Horizon faz scroll dentro de
    // .page-wrapper, por isso é esse o elemento que se escuta.
    const ler = () => {
      const r = capa.getBoundingClientRect();
      const t = Math.min(1, Math.max(0, -r.top / r.height));
      aplicar(0, t * 2);
    };
    // No computador rola .page-wrapper; no telemóvel rola a página.
    document.querySelector('.page-wrapper')?.addEventListener('scroll', ler, { passive: true });
    window.addEventListener('scroll', ler, { passive: true });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ventazano-diapositivos"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-vz-dia]').forEach((raiz) => {
    const menu = raiz.querySelector('[data-vz-menu]');
    const abrir = raiz.querySelector('[data-vz-abrir]');
    if (!menu || !abrir || typeof menu.showModal !== 'function') return;

    abrir.addEventListener('click', () => {
      menu.showModal();
      abrir.setAttribute('aria-expanded', 'true');
    });
    raiz.querySelector('[data-vz-fechar]')?.addEventListener('click', () => menu.close());
    // O `close` também dispara com o Escape: o foco volta ao botão que abriu.
    menu.addEventListener('close', () => {
      abrir.setAttribute('aria-expanded', 'false');
      abrir.focus();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ventazano-edicao"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.vz-ed').forEach((ed) => {
    const looks = [...ed.querySelectorAll('.vz-look[data-cor]')];
    const pagina = ed.querySelector('[data-vz-ed-pagina]');
    const numero = ed.querySelector('[data-vz-ed-n]');
    if (!looks.length || !pagina) return;

    // Tinta clara sobre parede escura: luminância relativa (WCAG) abaixo de
    // 0.36 pede texto claro.
    const tintaPara = (hex) => {
      const [r, g, b] = [1, 3, 5]
        .map((i) => parseInt(hex.slice(i, i + 2), 16) / 255)
        .map((c) => (c <= 0.03928 ? c / 12.92 : ((c + 0.055) / 1.055) ** 2.4));
      return 0.2126 * r + 0.7152 * g + 0.0722 * b < 0.36 ? '#f4f4f2' : '#0c0c0c';
    };

    const ativar = (look) => {
      const cor = look.dataset.cor;
      ed.style.setProperty('--vz-ed-fundo', cor);
      ed.style.setProperty('--vz-ed-tinta', tintaPara(cor));
      numero.textContent = look.dataset.n;
      pagina.style.setProperty('--fio', String((looks.indexOf(look) + 1) / looks.length));
    };

    // O look que ocupa o meio do ecrã é o que manda na cor.
    const olho = new IntersectionObserver((entradas) => {
      for (const e of entradas) if (e.isIntersecting) ativar(e.target);
    }, { rootMargin: '-45% 0px -45% 0px' });
    looks.forEach((l) => olho.observe(l));

    // O número de página só enquanto a Edição está à vista.
    new IntersectionObserver(([e]) => pagina.toggleAttribute('data-visivel', e.isIntersecting), {
      rootMargin: '-20% 0px -20% 0px',
    }).observe(ed);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ventazano-filme"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-vz-filme]').forEach((filme) => {
    const canvas = filme.querySelector('.vz-filme__canvas');
    const cartaz = filme.querySelector('.vz-filme__cartaz');
    const batidas = [...filme.querySelectorAll('[data-de]')];
    const listas = JSON.parse(filme.querySelector('[data-vz-filme-frames]').textContent);
    const reduzido = matchMedia('(prefers-reduced-motion: reduce)').matches;
    const urls = matchMedia('(max-width: 749px)').matches ? listas.m : listas.d;
    const total = urls.length;
    const ctx = canvas.getContext('2d');
    const imagens = new Array(total);

    // Enche o canvas como o object-fit: cover do cartaz, com a mesma âncora.
    const pintar = (img) => {
      const w = canvas.clientWidth, h = canvas.clientHeight;
      const dpr = Math.min(window.devicePixelRatio || 1, 2);
      if (canvas.width !== Math.round(w * dpr)) { canvas.width = Math.round(w * dpr); canvas.height = Math.round(h * dpr); }
      const escala = Math.max(canvas.width / img.naturalWidth, canvas.height / img.naturalHeight);
      const dw = img.naturalWidth * escala, dh = img.naturalHeight * escala;
      ctx.drawImage(img, (canvas.width - dw) / 2, (canvas.height - dh) * 0.3, dw, dh);
    };

    // O frame pedido, ou o mais próximo que já chegou.
    const perto = (i) => {
      for (let d = 0; d < total; d++) {
        if (imagens[i - d]?.complete && imagens[i - d].naturalWidth) return imagens[i - d];
        if (imagens[i + d]?.complete && imagens[i + d].naturalWidth) return imagens[i + d];
      }
      return null;
    };

    let pedido = 0, ultimo = -1;
    const atualizar = () => {
      cancelAnimationFrame(pedido);
      pedido = requestAnimationFrame(() => {
        const r = filme.getBoundingClientRect();
        const curso = r.height - window.innerHeight;
        const t = reduzido ? 1 : Math.min(1, Math.max(0, -r.top / (curso || 1)));
        filme.style.setProperty('--progresso', t.toFixed(4));
        const i = Math.round(t * (total - 1));
        const img = perto(i);
        if (img && i !== ultimo) { pintar(img); ultimo = i; cartaz.style.visibility = 'hidden'; }
        for (const b of batidas) {
          const de = parseFloat(b.dataset.de), ate = b.dataset.ate ? parseFloat(b.dataset.ate) : 2;
          b.toggleAttribute('data-visivel', reduzido ? !b.dataset.ate : t >= de && t < ate);
        }
      });
    };

    // Carregar: o primeiro e o último já, depois um em cada quatro (para o
    // scroll rápido ter sempre algo perto), e só então os que faltam.
    const carregar = (i) => {
      if (imagens[i]) return;
      const img = new Image();
      img.decoding = 'async';
      img.onload = () => { if (Math.abs(i - ultimo) <= 2 || ultimo === -1) { ultimo = -1; atualizar(); } };
      img.src = urls[i];
      imagens[i] = img;
    };
    carregar(0);
    carregar(total - 1);
    const resto = () => {
      for (let i = 0; i < total; i += 4) carregar(i);
      for (let i = 0; i < total; i++) carregar(i);
    };
    // O primeiro ato descarrega logo depois da página. Os seguintes só quando
    // a pessoa está a uma altura e meia de ecrã deles: o segundo filme pesa
    // 3 a 5 MB, e quem não desce até lá não os deve pagar.
    if (filme.hasAttribute('data-principal')) {
      if (document.readyState === 'complete') resto();
      else window.addEventListener('load', resto, { once: true });
    } else {
      new IntersectionObserver((entradas, olho) => {
        if (entradas.some((e) => e.isIntersecting)) { resto(); olho.disconnect(); }
      }, { rootMargin: '150% 0px 150% 0px' }).observe(filme);
    }

    // O Horizon faz scroll dentro de .page-wrapper no computador, mas no
    // telemóvel quem rola é a página. Ouvem-se os dois: só com o primeiro, o
    // filme ficava parado no frame 1 em todos os telemóveis.
    document.querySelector('.page-wrapper')?.addEventListener('scroll', atualizar, { passive: true });
    window.addEventListener('scroll', atualizar, { passive: true });
    window.addEventListener('resize', () => { ultimo = -1; atualizar(); });
    atualizar();
  });

  } catch(e) { console.error(e); }
})();
})();
